import { TOKEN_BLACKLIST } from 'vvs-config'

export const MINIMUM_SEARCH_CHARACTERS = 2

export const WEEKS_IN_YEAR = 52.1429

export const TOTAL_FEE = 0.003
export const LP_HOLDERS_FEE = 0.002
export const TREASURY_FEE = 0.0002
export const BUYBACK_FEE = 0.0008

export const BASE_URL = 'https://vvs.finance'

export const VVS_FINANCE_START = 1636354800 // FIXME start time
export const ONE_DAY_UNIX = 86400 // 24h * 60m * 60s
export const ONE_HOUR_SECONDS = 3600

export const ITEMS_PER_INFO_TABLE_PAGE = 10

// see packages/vvs-config/src/blacklistTokens.ts
export { TOKEN_BLACKLIST }
